export const profile = {
  Edit_your_profile: "Editar seu perfil",
  Logout: "Sair",
  Profile: "Perfil",
  language: "Idioma",
} as const;
